module.exports = "<a href ng-attr-title=\"{{ match.model.shortName }}\">\n  <div class=\"text-truncate\">\n    <span\n      ng-bind-html=\"match.model.shortName | uibTypeaheadHighlight:query\"\n    ></span>\n    <small\n      ng-if=\"match.model.city\"\n      ng-bind-html=\"match.model.city | uibTypeaheadHighlight:query\"\n      class=\"is-block\"\n    ></small>\n  </div>\n  <span\n    ng-bind-html=\"match.model.legacyBankIdentifier | uibTypeaheadHighlight:query\"\n    class=\"text-decent\"\n  ></span>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-bank-search/src/templates/bankSearchSuggest.html
// module id = 1153
// module chunks = 12